import { Link } from '@chakra-ui/next-js';
import { Flex } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { getNavLinks } from '@/shared/constants';
import ProductsMenu from './ProductsMenu';

const DesktopMenu = () => {
  const { t } = useTranslation();
  const navLinks = getNavLinks(t);

  return (
    <Flex
      alignItems='center'
      as='nav'
      display={{ base: 'none', lg: 'flex' }}
      gap={{ base: 'md', lg: 'lg', xl: '2xl' }}
    >
      {navLinks.map(({ title, items, href }) => {
        if (items) {
          return null;
        }

        return (
          <Link
            key={title}
            href={href!}
          >
            {title}
          </Link>
        );
      })}

      <ProductsMenu />
    </Flex>
  );
};

export default DesktopMenu;
